<template>
  <div class="wrapper my-2">
    <div class="menu d-flex flex-column">
      <div class="text-right mb-2">
        <v-hover
          v-slot="{ hover }"
        >
          <v-btn
            :color="hover ? 'white' : 'grey'"
            outlined
            rounded
            small
            @click="active = !active"
          >
            <v-icon small :left="hover">
              {{ active ? mdiArrowRightThin : mdiArrowLeftThin }}
            </v-icon>
            <template v-if="hover">
              {{ active ? 'Hide' : 'Show' }}
            </template>
          </v-btn>
        </v-hover>
      </div>
      <div
        v-for="button in buttons"
        :key="button.key"
        class="text-right mb-2"
      >
        <v-hover
          v-slot="{ hover }"
        >
          <v-btn
            :color="hover || value === button.key ? 'white' : 'grey'"
            outlined
            rounded
            small
            @click="button.click"
          >
            <v-icon small :left="hover || value === button.key">
              {{ button.icon }}
            </v-icon>
            <template v-if="hover || value === button.key">
              {{ button.name }}
            </template>
          </v-btn>
        </v-hover>
      </div>
    </div>
    <div v-show="active" class="sub-wrapper ml-2">
      <slot/>
    </div>
  </div>
</template>

<script>
import {
  mdiArrowLeftThin,
  mdiArrowRightThin,
  mdiMapClockOutline,
  mdiMapSearchOutline,
  mdiMapMarkerRadiusOutline,
  mdiChartTimelineVariant
} from '@mdi/js'
export default {
  props: {
    value: String
  },
  data () {
    return {
      mdiArrowLeftThin,
      mdiArrowRightThin,
      active: true,
      buttons: [
        {
          name: 'runtime',
          key: 'runtime',
          icon: mdiMapClockOutline,
          click: () => this.$emit('input', 'runtime')
        },
        {
          name: 'editor',
          key: 'editor',
          icon: mdiMapSearchOutline,
          click: () => this.$emit('input', 'editor')
        },
        {
          name: 'runtime markers',
          key: 'runtime-markers',
          icon: mdiMapMarkerRadiusOutline,
          click: () => this.$emit('input', 'runtime-markers')
        },
        {
          name: 'telemetry',
          key: 'telemetry',
          icon: mdiChartTimelineVariant,
          click: () => this.$emit('input', 'telemetry')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrapper {
    background-color: transparent;
    position: absolute;
    height: calc(100% - 16px);
    right: 0;
    top: 0;
    z-index: 999;
  }

  .sub-wrapper {
    width: 300px;
    height: 100%;
    overflow-y: auto;
  }

  .menu {
    position: absolute;
    top: 0;
    right: 100%;
  }
</style>